export default "__VITE_ASSET__B74siuqT__"